import { parseJsonObject } from "../../../features/builder.utils";

// Pure helpers of the Channel tab (no API, no React).

/** "Delivered" for phase 1, "Not delivered yet" for a channel whose sender comes later. */
export const phaseText = (phase) => (phase === null || phase === undefined ? "—" : phase > 1 ? "Not delivered yet" : "Delivered");

export const rateLimitText = (value) => (value === null || value === undefined || value === "" ? "No limit" : `${value} / min`);

/** The handler (sender) a form is about. */
export const handlerOf = (formData, dependencies) => (dependencies?.handlers || []).find((handler) => handler.id === formData?.channel_key) ?? null;

const toNumberOrNull = (value) => (value === "" || value === null || value === undefined ? null : Number(value));

/** EntityFormModal values -> create / update payload. Schemas are sent only when "Edit schemas as JSON" is on. */
export const toChannelPayload = (values, isEdit) => ({
  ...(isEdit ? {} : { channel_key: values.channel_key }),
  name: values.name?.trim() ?? "",
  description: values.description?.trim() || null,
  icon: values.icon?.trim() || null,
  rate_limit_per_min: toNumberOrNull(values.rate_limit_per_min),
  sort_order: toNumberOrNull(values.sort_order) ?? 0,
  supports_digest: !!values.supports_digest,
  supports_html: !!values.supports_html,
  is_activated: !!values.is_activated,
  ...(values.edit_schemas && {
    template_schema: parseJsonObject(values.template_schema_text ?? ""),
    config_schema: parseJsonObject(values.config_schema_text ?? "") ?? null,
  }),
});
